module.exports = __webpack_public_path__ + "img/indicador_aire.2df5de03.png";